export type UnionRecord<T extends string> = Record<T, null>

export const getUnionValues = <T extends string>(record: UnionRecord<T>): T[] => {
  return Object.keys(record) as T[]
}
